import View from "./user-form.view";
import Presenter from "./user-form.presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.registration.user.form",
    url: "/:userUuid/editar",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/index.js